// Console-themed appearance for every Clerk-rendered surface (SignIn,
// UserButton, UserProfile, ...). Adapted from the AIF studio's
// `apps/web/src/lib/clerkAppearance.ts` -- the AIF version layers Tailwind
// utility classes on top, while the console is plain-CSS. Here we use
// Clerk's `variables` knob to align the widget with the console's
// existing dark token palette, then add a single `rootBox` class
// (`ghllite-clerk-root`) so additional console rules in `styles.css`
// can refine specific elements if needed.
//
// Used as `<ClerkProvider appearance>` in `main.tsx` so the prebuilt
// SignIn component matches the rest of the console.
export const clerkAppearance = {
  variables: {
    colorPrimary: "rgb(251 191 36)",
    colorTextOnPrimaryBackground: "rgb(10 10 12)",
    colorBackground: "rgb(15 15 18)",
    colorText: "rgb(250 250 250)",
    colorTextSecondary: "rgb(161 161 170)",
    colorInputBackground: "rgb(23 23 31)",
    colorInputText: "rgb(250 250 250)",
    colorNeutral: "rgb(255 255 255)",
    colorDanger: "rgb(244 63 94)",
    colorSuccess: "rgb(16 185 129)",
    colorWarning: "rgb(245 158 11)",
    borderRadius: "0.5rem",
    fontFamily: '"Geist", "Inter", "system-ui", sans-serif',
    fontFamilyButtons: '"Geist", "Inter", "system-ui", sans-serif',
    fontSize: "0.875rem",
  },
  elements: {
    rootBox: "ghllite-clerk-root",
    card: "ghllite-clerk-card",
  },
  layout: {
    socialButtonsPlacement: "bottom" as const,
    socialButtonsVariant: "blockButton" as const,
    showOptionalFields: false,
  },
};
